import { IEecsAccount, IEecsGoAccount, SetGoAccountsPayload } from 'types';

export enum EGrexCountry {
  DENMARK = 'DK',
}

export interface IGrexAccounts {
  [EGrexCountry.DENMARK]: IEecsAccount | null;
}

export interface IGrexGoAccounts {
  [EGrexCountry.DENMARK]: IEecsGoAccount[];
}

export interface ConnectAccountPayload {
  country_code: EGrexCountry;
  account_holder_code: string;
}

export interface ConnectAccountResponse {
  url: string;
}

export interface GetGoAccountsPayload {
  id: number;
}

export interface SaveGoAccountsPayload extends SetGoAccountsPayload {
  id: number;
}

export interface DisconnectAccountPayload extends GetGoAccountsPayload {}

export interface ConfirmConnectAccountPayload {
  state: string;
  code: string;
}
